import React from 'react'
import { NavLink } from 'react-router-dom'

const Tab = ({ icon, path, title }) => {
    return (
        <NavLink to={path} className={({ isActive }) => (isActive ? 'tab border-b-4 border-[#0E86D4] rounded-t-[10px] text-[#0E86D4]' : 'tab hover: rounded-t-[10px] group')}>
            {({ isActive }) => (
                <>
                    <div className={isActive ? " mr-[10px] text-[#0E86D4]" : "group-hover:text-[#0E86D4] mr-[10px]"}>
                        {icon}
                    </div>
                    <div
                        className={`${isActive ? 'text-[#0E86D4]' : 'group-hover:text-[#0E86D4]'} text-[10px] sm:text-[base] md:text-lg lg:text-xl`}
                    >
                        {title}
                    </div>

                </>
            )}
        </NavLink>
    )
}

export default Tab
